import type { BrokerEfficiencyData } from '../../../hooks/pipelineTracker/useOperationsOverview';
import { shortMonth } from './operationsParts';

export type EfficiencyMetric = 'leads' | 'submissions' | 'settlements';

/**
 * One chart's rows: a point per month, a column per broker series.
 *
 * Pure so the shaping is tested without Recharts, which draws nothing in jsdom. Each series is
 * keyed by its index (`s0`, `s1`) rather than by name, because a broker's name is free text and a
 * dot or a bracket in it would be read by Recharts as a path into the row object.
 */
export function efficiencyChartRows(
  data: BrokerEfficiencyData,
  metric: EfficiencyMetric
): Array<Record<string, number | string>> {
  return data.months.map((month, i) => {
    const row: Record<string, number | string> = { month: shortMonth(month) };
    data.series.forEach((series, s) => {
      row[`s${s}`] = series[metric][i] ?? 0;
    });
    return row;
  });
}

/** Chart palette, the tracker's stage colours in the same order. */
export const SERIES_COLOURS = [
  '#3b82f6', '#16a34a', '#f59e0b', '#a78bfa', '#0891b2',
  '#ec4899', '#eab308', '#0ea5e9', '#22c55e', '#7c3aed',
];
